module.exports = __webpack_public_path__ + "img/notificaiton-queue-whatsapp.3affa4f9.png";